import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TeachersComponent } from './teacher-profile/teacher-profile.component';
import { LandingComponent } from './landing/landing.component';
import { FindPartnersComponent } from './find-partners/find-partners.component';
import { PartnerProfileComponent } from './partner-profile/partner-profile.component';
import { PartnerSubmissionComponent } from './partner-submission/partner-submission.component';
import { AccountRecoveryComponent } from './account-recovery/account-recovery.component';
import { TeacherRegisterComponent } from './teacher-register/teacher-register.component';
import { UserHelpComponent } from './user-help/user-help.component';
import { NewProjectComponent } from './new-project/new-project.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProjectDetailsComponent } from './project-details/project-details.component';
import { FindProjectsComponent } from './find-projects/find-projects.component';
import { WhoWeAreComponent } from './who-we-are/who-we-are.component.';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { RecyclingBinComponent } from './recycling-bin/recycling-bin.component';
import {HomeComponent} from "./home/home.component";
import {EventsFormComponent} from "./events-form/events-form.component";
import {AcknowledgementsComponent} from "./acknowledgements/acknowledgements.component";
import {GrantsComponent} from "./grants/grants.component";
import {AnnualSchoolProfilesComponent} from "./annual-school-profiles/annual-school-profiles.component";
import {AnnualSchoolProfilesFormComponent} from "./annual-school-profiles-form/annual-school-profiles-form.component";
import {
  AnnualSchoolProfilesDetailsComponent
} from "./annual-school-profiles-details/annual-school-profiles-details.component";
import {authGuard} from "./auth.guard";
import {roleGuard} from "./role.guard";
import { DraftsComponent } from "./drafts/drafts.component";
import {DashboardSearchResultComponent} from "./dashboard-search-result/dashboard-search-result.component";
import {ReportsComponent} from "./reports/reports.component";
import {GrantsFormComponent} from "./grants-form/grants-form.component";
import {GrantsDetailsComponent} from "./grants-details/grants-details.component";
import {EventsComponent} from "./events/events.component";
import {EventsDetailsComponent} from "./events-details/events-details.component";
import {AdminUserCreationComponent} from "./admin-user-creation/admin-user-creation.component";
import { UnsavedChangesGuard } from './unsaved-changes.guard';

const routes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  { path: 'landing', component: LandingComponent },
  {path: 'register', component: TeacherRegisterComponent},
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {path: 'profile', component: TeachersComponent},
      {path: 'find-partners', component: FindPartnersComponent},
      {path: 'partner/:id', component: PartnerProfileComponent},
      {path: 'partner-submission', component: PartnerSubmissionComponent,
        canActivate: [roleGuard], data: {allowedRoles: ['admin', 'ghs teacher representative', 'teacher']}},
      {path: 'accountRecover', component: AccountRecoveryComponent},
      {path: 'help', component: UserHelpComponent},
      {path: 'new-projects', redirectTo: 'new-project', pathMatch: 'full'},
      {path: 'new-project', component: NewProjectComponent,
        canActivate: [roleGuard], data: {allowedRoles: ['admin', 'ghs teacher representative', 'teacher']}, canDeactivate: [UnsavedChangesGuard]},
      {path: 'admin-dashboard', component: DashboardComponent},
      {path: 'inactive', component: RecyclingBinComponent},
      {path: 'find-projects', component: FindProjectsComponent},
      {path: 'about-us', component: WhoWeAreComponent},
      {path: 'contact-us', component: ContactUsComponent},
      {path: 'project/:id', component: ProjectDetailsComponent},
      //{path: '', redirectTo: 'home', pathMatch: 'full'},
      {path: 'home', component: HomeComponent},
      {path: 'new-events', component: EventsFormComponent},
      {path: 'acknowledgements', component: AcknowledgementsComponent},
      {path: 'grants', component: GrantsComponent},
      {path: 'annual-school-profiles', component: AnnualSchoolProfilesComponent,
        canActivate: [roleGuard], data: {allowedRoles: ['admin', 'ghs teacher representative', 'teacher']}},
      {path: 'annual-school-profiles-form', component: AnnualSchoolProfilesFormComponent,
        canActivate: [roleGuard], data: {allowedRoles: ['admin', 'ghs teacher representative', 'teacher']}},
      {path: 'annual-school-profiles/:id', component: AnnualSchoolProfilesDetailsComponent,
        canActivate: [roleGuard], data: {allowedRoles: ['admin', 'ghs teacher representative', 'teacher']}},
      { path: 'drafts', component: DraftsComponent },
      { path: 'dashboard-search-result', component: DashboardSearchResultComponent,
      canActivate: [roleGuard], data: {allowedRoles: ['admin', 'ghs teacher representative', 'teacher']}},
      {path: 'reports', component: ReportsComponent},
      { path: 'grants-form', component: GrantsFormComponent,
        canActivate: [roleGuard], data: {allowedRoles: ['admin']}},
      { path: 'grants/:id', component: GrantsDetailsComponent,},
      { path: 'events', component: EventsComponent,},
      { path: 'events-form', component: EventsFormComponent,
        canActivate: [roleGuard], data: {allowedRoles: ['admin']}},
      { path: 'events/:id', component: EventsDetailsComponent,},
      {path: 'admin-user-creation', component: AdminUserCreationComponent,
        canActivate: [roleGuard], data: {allowedRoles: ['admin']}}
    ],
  },

  {path: '**', redirectTo: 'landing'},

];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
